export default __webpack_public_path__ + "static/media/Team.6a4cc30b.svg";